// src/components/LayerSwitcher.jsx
import React from 'react';
import { Select, MenuItem, FormControl, InputLabel, Box } from '@mui/material';

const LayerSwitcher = ({ selectedLayer, handleLayerChange, drawerOpen }) => {
  return (
    <Box
    sx={{
      backgroundColor: 'white', // Ensure the background is white
      boxShadow: 3, // Apply a standard shadow (adjust as needed)
      borderRadius: '4px', // Optional: Add rounded corners for better aesthetics
      padding: '10px', // Optional: Add padding inside the box
      position: 'absolute', // Absolute positioning for proper layout
      bottom: '10px', // Keep it at the bottom
      right: drawerOpen ? '320px' : '10px', // Shifts based on drawer state
      zIndex: 1000, // Ensure it's above other elements
      transition: 'right 0.3s', // Smooth transition when the drawer is toggled
    }}
  >
    <FormControl
      sx={{
        minWidth: 150,
      }}
    >
      <InputLabel id="layer-switcher-label">Map Layer</InputLabel>
      <Select
        labelId="layer-switcher-label"
        value={selectedLayer}
        label="Map Layer"
        onChange={handleLayerChange}
      >
        <MenuItem value="satellite">Satellite</MenuItem>
        <MenuItem value="osm">OpenStreetMap</MenuItem>
      </Select>
    </FormControl>
  </Box>
  
  );
};

export default LayerSwitcher;
